import React, {useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import { parse, format, isValid } from 'date-fns';
import airlines from "../data/airlines.json";
import airportsData from '../data/airports.json';
import Modal from 'react-bootstrap/Modal';
import AutocompleteAirport from "../Components/AutocompleteAirport";
import DatePicker from 'react-datepicker';
import Swal from 'sweetalert2'

function BookingDestination(){

    const dest = localStorage.getItem('destination');
    
    const [origin, setOrigin] = useState("LHR");
    const [destination, setDestination] = useState(dest);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [username, setName] = useState("");
    const [useremail, setEmail] = useState("");
    const [phonenumber, setPhone] = useState("");

    

    const location = useLocation();
    const { selectedFlight } = location.state || {};
    console.log(selectedFlight);

     // Function to get the airline name by code
    const getAirlineName = (code) => {
        const airline = airlines.find((airline) => airline.code === code);
        return airline ? airline.name : "Unknown Airline";
    };

    // Function to get the airport name by code
    const getAirportName = (code) => {
      const airport = airportsData.find(airport => airport.code === code);
      return airport ? airport.name : 'Airport not found';
    };

    const formatDsiplayDate = (dateStr) => {
        const date = new Date(dateStr);
        // Get the day, month, and year
        const day = String(date.getDate()).padStart(2, "0");
        const month = date.toLocaleString("en-GB", { month: "short" }); // e.g., "Oct"
        const year = date.getFullYear();

        // Construct the formatted date string
        return `${day} ${month}, ${year}`;
    };

    const extractTime = (timestamp) => {
        const date = new Date(timestamp);
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${hours}:${minutes}`;
    };

    const formatDuration = (duration) => {
        const regex = /PT(\d+H)?(\d+M)?/; // Regex to extract hours and minutes
        const match = duration.match(regex);

        const hours = match[1] ? match[1].replace("H", "") : "0";
        const minutes = match[2] ? match[2].replace("M", "") : "0";

        return `${hours}h ${minutes}min`;
    };

    {/*Horizontal Arrow*/}
    const FlightStopsArrowHorizontal = (totalStopss) => {
        return (
        <div>
            <div className="TransportTimeline__LineWrapper">
            <div className="TransportTimeline__Line"></div>
            <div className="TransportTimeline__Triangle"></div>
            <div className="TransportTimeline__Dots">
                {Array.from({ length: totalStopss }).map((_, index) => (
                <div className="TransportTimeline__Dot" key={index}></div>
                ))}
            </div>
            </div>
            <small className="stops-text">
            {totalStopss === 0
                ? "Direct"
                : `${totalStopss} ${totalStopss === 1 ? "stop" : "stops"}`}
            </small>
        </div>
        );
    };

    
     const handleDateChange = (dateOrDates) => {
       
            const [start, end] = dateOrDates; // Array destructuring for "Round Trip"
            setStartDate(start);
            setEndDate(end);
            
    };
    // Disable keyboard input on datepicker field
    const disableKeyboardInput = (event) => {
        event.preventDefault();
    };

     /*Validation and Form Submission*/
    const [errors, setErrors] = useState({});
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10,15}$/;
    // Validate required fields
    const validateForm = () => {
        const newErrors = {};
        if (!origin) newErrors.origin = 'Origin is required';
        if (!destination) newErrors.destination = 'Destination is required';
        if (!startDate && !endDate) newErrors.dateError = 'Travel dates are required';
        
        
        if (!username) newErrors.username = 'Name is required';
        if (!useremail) {
            newErrors.useremail = 'Email is required';
        } else if (!emailRegex.test(useremail)) {
            newErrors.useremail = 'Invalid email format';
        }
        if (!phonenumber) {
            newErrors.phonenumber = 'Phone number is required';
        } else if (!phoneRegex.test(phonenumber)) {
            newErrors.phonenumber = 'Invalid phone number format (must be 10-15 digits)';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

   
    const handleSearch = async (e) => {
        e.preventDefault();
        if (validateForm()) { 

            const formData = {
                "tripType":"Round Tripe",
                "originFullName":getAirportName(origin),
                "destinationFullName":getAirportName(destination),
                startDate,
                endDate,
                "adults":"1",
                "children": "0",
                "infants": "0",
                username,
                useremail,
                phonenumber,
                "selectedFlight":localStorage.getItem("selectedFlightairline"),
                "selectedPrice":localStorage.getItem("selectedFlightPrice")
            };
           
            try {
                const response = await fetch('https://7skyseo.com/holiday-expert-server-side-files/search-detail-inquiry.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
                });
                 
                Swal.fire({
                    title: "Thank You",
                    icon: "success",
                    text: "We are working on your Request, Our Team will contact you shortly."
                    }).then(okay => {
                    if (okay) {
                        window.location.href = "http://localhost:3000/";
                    }
                });
                
            } catch (error) {
                console.error('Error:', error);
            }

           
            
        }    
    };

    return(
        <>
        {/* BreadCrumb Starts */}  
        <section className="breadcrumb-main pb-5 pt-5 bookingHeaderSection" >
            <div className="section-shape section-shape1 top-inherit bottom-0" ></div>
            <div className="breadcrumb-outer">
                <div className="container">
                    <div className="breadcrumb-content text-center">
                        <h1 className="mb-3">Booking</h1>
                    </div>
                </div>
            </div>
        </section>
        {/* BreadCrumb Ends */} 

        <section className="trending pt-6 pb-0 bg-lgrey">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-xs-12 mb-4">
                        <div className="payment-book">
                            <div className="booking-box">
                               
                                <div className="row flightRow item mb-2 p-3 px-4 rounded" >
                                    <div className="col-lg-10" >
                                    {selectedFlight.itineraries.map( (itinerary, itineraryIndex) => {
                                    //Total Stops Calculate
                                    const segments = itinerary.segments;
                                    const totalStops = segments.length - 1; // Number of stops is one less than the number of segments

                                    // Extract start and end times for each itinerary
                                    const firstSegment = itinerary.segments[0];
                                    const lastSegment =
                                        itinerary.segments[
                                        itinerary.segments.length - 1
                                        ];
                                    const startTime = extractTime(
                                        firstSegment.departure.at
                                    );
                                    const endTime = extractTime(
                                        lastSegment.arrival.at
                                    );
                                    const startDateFlight = formatDsiplayDate(
                                        firstSegment.departure.at
                                    );
                                    const EndDateFlight = formatDsiplayDate(
                                        lastSegment.arrival.at
                                    );
                                    const duration = formatDuration(
                                        itinerary.duration
                                    );

                                    //Origin Destination Names
                                    const originName =
                                        firstSegment.departure.iataCode;
                                    const destinationName =
                                        lastSegment.arrival.iataCode;
                                   
                                    // Airline details for the first segment of each itinerary
                                    const airlineCode = firstSegment.carrierCode;
                                    const airlineName =
                                        getAirlineName(airlineCode);
                                    const flightNumber = firstSegment.number;  
                                    return (
                                        <div
                                        className="row text-center itry"
                                        key={itineraryIndex}
                                        >
                                        <div className="col-lg-4 itryAirline">
                                            <div className="item-inner-image">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/assets/images/airline/${airlineCode}.png`}
                                                alt="image"
                                                className="resultPlane"
                                            />
                                            <h5 className="mb-0 airlineName">
                                                {airlineName}
                                            </h5>
                                            <small>
                                                {airlineCode} {flightNumber}
                                            </small>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 itryFlightTime">
                                            <div className="item-inner">
                                            <div className="content">
                                                <h3 className="mb-0 flightTime">
                                                {startTime}
                                                </h3>
                                                <small className="mb-0 text-uppercase">
                                                {originName}
                                                </small>
                                                <br />
                                                <small className="mb-0 text-uppercase">
                                                {startDateFlight}
                                                </small>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 itryFlightDuration">
                                            <div className="item-inner flight-time">
                                            <small className="mb-0">
                                                {duration}
                                            </small>
                                            <br />
                                            {FlightStopsArrowHorizontal(
                                                totalStops
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-lg-3 itryFlightTime">
                                            <div className="item-inner">
                                            <div className="content">
                                                <h3 className="mb-0 flightTime">
                                                {endTime}
                                                </h3>
                                                <small className="mb-0 text-uppercase">
                                                {destinationName}
                                                </small>
                                                <br />
                                                <small className="mb-0 text-uppercase">
                                                {EndDateFlight}
                                                </small>
                                            </div>
                                            </div>
                                        </div>
                                        {itineraryIndex === 0 && (
                                            <div
                                            className="border-t"
                                            style={{ margin: "10px 0" }}
                                            ></div>
                                        )}
                                        </div>
                                    );   
                                    }      
                                    )}  
                                </div>
                                <div className="col-lg-2">    
                                    <p className="theme2 fs-4 fw-bold">
                                    £{selectedFlight.price.total}
                                    </p>  
                                </div>       
                                </div>
                                <div className="travellers-info row mb-4">
                                    <h4>Traveler Information</h4> 

                                    <div className="col-lg-4 mb-2 departureField">
                                        <div className="form-group ">
                                            <label className="mb-3"></label>
                                            <div className="input-box autoComplete">
                                            <AutocompleteAirport label="Flying From?" onSelectAirport={setOrigin}  autoComplete="off" defaultValue={origin} />
                                            {errors.origin && <p style={{ color: 'red' }}>{errors.origin}</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-2 destinationField">
                                        <div className="form-group">
                                            <div className="input-box autoComplete">
                                                <label className="mb-3"></label> 
                                                <AutocompleteAirport label="Flying To?" onSelectAirport={setDestination} defaultValue={destination} />
                                                {errors.destination && <p style={{ color: 'red' }}>{errors.destination}</p>}
                                            </div>
                                        </div>
                                    </div>                                    
                                    <div className="col-lg-4 mb-2 dateSelectionField bookingDestinalDateSelection">
                                        <div className="form-group ">
                                            <div className="input-box">
                                            <label className="mb-3"></label>
                                            {/*<span className='searchFormIcons'><FaRegCalendarAlt /></span>*/}
                                            <DatePicker
                                                id="date-range"
                                                selected={startDate}
                                                onChange={handleDateChange}
                                                startDate={startDate}
                                                endDate={endDate}
                                                selectsRange
                                                monthsShown={2} // Show 2 months in one view
                                                minDate={new Date()} // Disable past dates 
                                                placeholderText={
                                                    "Select your travel dates"
                                                }
                                                autoComplete="off"
                                                dateFormat="dd/MM/yyyy"
                                                onKeyDown={disableKeyboardInput} // Disable keyboard input
                                                popperPlacement="bottom-end"
                                                popperProps={{
                                                    positionFixed: true
                                                }}
                                                withPortal
                                                onFocus={e => e.target.blur()}
                                            />
                                             {errors.dateError && <p style={{ color: 'red' }}>{errors.dateError}</p>}
                                            </div>
                                        </div>
                                    </div>   
                                    <div className='col-lg-4 searchFullName'>
                                        <div class="form-group">
                                            <div class="input-box">
                                                <label></label>
                                                <input type="text" name="fullname" autoComplete="off" placeholder='Your Name' value={username} onChange={(e) => setName(e.target.value)} />
                                                {errors.username && <p style={{ color: 'red' }}>{errors.username}</p>}
                                            </div>
                                        </div>
                                    </div> 
                                    <div className='col-lg-4 searchEmail'>
                                        <div class="form-group">
                                            <div class="input-box">
                                                <label></label>
                                                <input type="email" name="useremail" autoComplete="off" placeholder='Your Email' value={useremail} onChange={(e) => setEmail(e.target.value)} />
                                                {errors.useremail && <p style={{ color: 'red' }}>{errors.useremail}</p>}
                                            </div>
                                        </div>
                                    </div> 
                                    <div className='col-lg-4 searchPhoneNumber'>
                                        <div class="form-group">
                                            <div class="input-box">
                                                <label></label>
                                                <input type="text" name="phonenumber" autoComplete="off" placeholder='Your Phone' value={phonenumber} onChange={(e) => setPhone(e.target.value)} />
                                                {errors.phonenumber && <p style={{ color: 'red' }}>{errors.phonenumber}</p>}
                                            </div>
                                        </div>
                                    </div> 

                                    <div className="col-lg-12 mb-2 flightSearchBtn">
                                        <div className="form-group mb-0 text-center">
                                            <div className="input-box">
                                                <label className="mb-3"></label><br />
                                                <button className="nir-btn w-100 search-button" onClick={handleSearch}>Submit</button>
                                            </div>    
                                        </div>
                                    </div> 
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-xs-12 mb-4 ps-4">
                        <div className="sidebar-sticky">
                            <div className="list-sidebar">
                                <div className="sidebar-item bordernone bg-white rounded box-shadow overflow-hidden p-3 mb-4">
                                    <h4>Ready to book?</h4>
                                    <div className="sidebar-module-inner">
                                        <p className="mb-2">Call us now for unbeatable prices and expert help</p>
                                        
                                    </div>
                                </div>
                                <div className="sidebar-item bg-white rounded box-shadow overflow-hidden p-3 mb-4">
                                    <h4>Why booking with us?</h4>
                                    <div className="sidebar-module-inner">
                                        <ul className="featured-list-sm">
                                            <li className="border-b pb-2 mb-2">
                                                <h6 className="mb-0">No Booking Charges</h6>
                                                We don't charge you an extra fee for booking a hotel room with us
                                            </li>
                                            <li className="border-b pb-2 mb-2">
                                                <h6 className="mb-0">No Cancellation Sees</h6>
                                                We don't charge you a cancellation or modification fee in case plans change
                                            </li>
                                            <li className="border-b pb-2 mb-2">
                                                <h6 className="mb-0">Instant Confirmation</h6>
                                                Instant booking confirmation whether booking online or via the telephone
                                            </li>
                                            <li>
                                                <h6 className="mb-0">Flexible Booking</h6>
                                                You can book up to a whole year in advance or right up until the moment of your stay
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        </>   
    )
}
export default BookingDestination;